import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from 'src/app/shared/services/form.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-hsa-are-you-sure',
  templateUrl: './hsa-are-you-sure.component.html',
  styleUrls: ['./hsa-are-you-sure.component.scss']
})
export class HsaAreYouSureComponent implements OnInit {
  hsaForm: FormGroup;
  constructor(private formService: FormService, private dialogRef: MatDialogRef<HsaAreYouSureComponent>) { }

  ngOnInit(): void {
    this.hsaForm = this.formService.clientHSADetailsForm;
  }

  onClose() {
    this.dialogRef.close();
  } 
  
  wantToInvest(areYouSure: boolean){
    //close modal no matter the selection
    this.dialogRef.close({ areYouSure });
  }
}
